"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyTransfer = void 0;
exports.emptyTransfer = {
    target: '',
    winstonQty: '0'
};
//# sourceMappingURL=CreateContract.js.map